<template>
  <a-modal
    v-bind="attrs"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :centered="true"
    title="复制文件夹"
    okText="确认"
  >
    <div class="mt-20">是否确认复制文件夹（文件夹名称）？</div>
    <a-radio-group class="mt-10" v-model:value="selectValue">
      <a-radio class="mb-10" style="width: 100%" value="0">仅复制文件夹结构，不饱含素材</a-radio>
      <a-radio style="width: 100%" value="1">复制文件夹结构，并复制所饱含的素材</a-radio>
    </a-radio-group>
    <div class="mb-20" style="color: #ccc">素材存在于多个文件夹中，不占用额外存储空间</div>
  </a-modal>
</template>

<script setup>
import {
  Modal as AModal,
  RadioGroup as ARadioGroup,
  Radio as ARadio,
  message
} from 'ant-design-vue'
import { ref, useAttrs, watch } from 'vue'
import { aigcStore } from '@/store/aigcStore'
import { copyFolder } from '@/service/api/aiDam'
import eventsBus from '@/utils/eventsBus'

const emits = defineEmits(['asyncSuccess'])

const store = aigcStore()
const attrs = useAttrs()
const confirmLoading = ref(false)
const selectValue = ref('0')

const handleOk = () => {
  confirmLoading.value = true
  copyFolder(
    {
      folderId: store.copyFolderData.id,
      copyType: selectValue.value,
      targetFolderId: store.copyFolderData.parentId
    },
    store.copyFolderData.id
  ).then((res) => {
    if (res.data) {
      message.success('复制成功')
      emits('asyncSuccess', selectValue.value)
      eventsBus.emit('copyFolder')
    }
    confirmLoading.value = false
  })
}

watch(
  () => attrs.open,
  (val) => {
    confirmLoading.value = false
    if (val) {
      console.log(store.sortFolderData)
    }
  }
)
</script>

<style lang="less" scoped></style>
